import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import getSectionInView from 'services/getSectionInView';

const getCurrentLocation = () => {
  const currentTopic: any = getCurrentTopic();
  const { sections, section, index } = getSectionInView();
  const interactions = getInteractionsInTopic(currentTopic);

  if (!interactions || interactions.length === 0) {
    return;
  }

  const interaction = interactions[index];

  return `${currentTopic.props.sId || currentTopic.id}/${interaction.props
    .sId || interaction.id}`;
};

export default getCurrentLocation;
